import { projectId } from './info';

// Keep non-production projects on their own Supabase hostname.
export const SUPABASE_URL = projectId === 'sbuatwyiqtzloxzljnfa'
  ? 'https://api.contractgroup.co.uk'
  : `https://${projectId}.supabase.co`;
